import React, { useState } from 'react';
import { Element } from 'react-scroll';
import { Collapse } from 'reactstrap';
import { useDesktop } from '../hooks';

const desktopClassName = (desktop: boolean): string =>
  desktop ? 'container-fluid bg-light-gray pt30 pb30' : 'container-fluid';

const reasonsClassName = (collapse: boolean): string =>
  collapse
    ? 'col-12 border-bottom pt30 pb30 d-block d-md-none mb20'
    : 'col-12 border-bottom pt30 pb30 d-block d-md-none';

export default function ProductRequirements() {
  const desktop = useDesktop();
  const [collapse, setCollapse] = useState(desktop);

  const toggle = () => setCollapse(!collapse);

  return (
    <div className={desktopClassName(desktop)}>
      <div className="container">
        <div className="row">
          <div
            className={reasonsClassName(collapse)}
            onClick={toggle}
            role="presentation"
          >
            <i className="material-icons align-middle">keyboard_arrow_right</i>
            Requisitos
          </div>
          <Collapse className="col-12" isOpen={collapse}>
            <Element name="requirements" className="col-12">
              <h2 className="px-24 text-center mb40">
                Requisitos de asegurabilidad
              </h2>
            </Element>
            <ul className="col-12 col-sm-10 d-flex flex-wrap text-primary mx-auto mb0">
              <li className="col-12 col-sm-6">
                <p className="text-dark-gray">
                  Edad de aceptación: 18 a 64 años
                </p>
              </li>
              <li className="col-12 col-sm-6">
                <p className="text-dark-gray">
                  Renovación automática hasta los 69 años
                </p>
              </li>
              <li className="col-12 col-sm-6">
                <p className="text-dark-gray">
                  Cancelación automática a los 70 años
                </p>
              </li>
              <li className="col-12 col-sm-6">
                <p className="text-dark-gray">
                  Ser titular o adicional de tu tarjeta de crédito Falabella Soriana
                </p>
              </li>
            </ul>
          </Collapse>
        </div>
      </div>
    </div>
  );
}
